module.exports = __webpack_public_path__ + "img/9791185871004.2d043dc7.jpg";